"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DARK_BASE_COLORS = exports.LIGHT_BASE_COLORS = void 0;
exports.LIGHT_BASE_COLORS = {
    emptyShade: '#FFF',
    lightestShade: '#F1F4FA',
    lightShade: '#D3DAE6',
    mediumShade: '#98A2B3',
    darkShade: '#69707D',
    darkestShade: '#343741',
    title: '#1A1C21',
};
exports.DARK_BASE_COLORS = {
    emptyShade: '#1D1E24',
    lightestShade: '#25262E',
    lightShade: '#343741',
    mediumShade: '#535966',
    darkShade: '#98A2B3',
    darkestShade: '#D4DAE5',
    title: '#DFE5EF',
};
//# sourceMappingURL=base_colors.js.map